import {useMutation} from "@tanstack/react-query";
import {readAccountApi} from "../../../../../api/account/AccountApi";
import {useEffect} from "react";
import {AccountSearchProps} from "../interface/searchInterface";
import {useSearchParams} from "react-router-dom";
import useGoToNavigation from "../../../../../util/useGotoNavigation";

export const AccountSearch = ({
                                  setSearchData,
                                  setDataCount,
                                  searchParam,
                                  setSearchParam,
                                  refresh,
                                  setRefresh
                              }: AccountSearchProps) => {
    const page = Number(useSearchParams()[0].get("pageNo")) || 1;
    const {goToNavigation} = useGoToNavigation();

    const readAccountApiMutate = useMutation({
        mutationFn: () => readAccountApi(searchParam),
        onSuccess: res => {
            if (res.data.code === "0000") {
                setSearchData(res.data.result.userList);
                setDataCount(res.data.result.totalCount)
            } else {
            }
        },
        onError: res => {
            alert(res)
        }
    });

    useEffect(() => {
        readAccountApiMutate.mutate()
    }, [])

    useEffect(() => {
        setSearchParam({...searchParam, pageNo: page});
    }, [page]);

    useEffect(() => {
        readAccountApiMutate.mutate();
    }, [searchParam.pageNo]);

    useEffect(() => {
        if (refresh) {
            readAccountApiMutate.mutate()
            setRefresh(!refresh)
        }
    }, [refresh])

    return (
        <>
            <div className="fiter_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">계정 검색</h3>
                    <div className="filter_toolbar"></div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <div className="frm_row search justify-content-start">
                            <label htmlFor="" className="form-label frm_label">검색어</label>
                            <select className="form-select"
                                    onChange={(e) => setSearchParam({...searchParam, keywordType: e.target.value})}>
                                <option value={'0'}>전체</option>
                                <option value={'1'}>이름</option>
                                <option value={'2'}>ID</option>
                                <option value={'3'}>회사명</option>
                            </select>
                            <input type="text"
                                   className="form-control"
                                   onChange={(e) => setSearchParam({...searchParam, keyword: e.target.value})}
                                   onKeyDown={e => e.key === "Enter" ? readAccountApiMutate.mutate() : ""}
                            />
                            <button className="btn btn-info btn_search" onClick={() => {
                                if (searchParam.pageNo && searchParam.pageNo === 1) {
                                    readAccountApiMutate.mutate();
                                } else {
                                    goToNavigation("customer/correspondent/list?pageNo=1", "", false)
                                }
                            }}>
                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt=""/>조회
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
